import { Box } from '@mui/material';
import styled from 'styled-components';
import { theme } from 'styles/mui-config';

export const StyledPageTitle = styled(Box)`
   width:100%;
   padding:10px;
   padding-top:10px;
   padding-bottom:10px;
   margin-top:16px;
   background-color:${theme.palette.primary.main};
   border-radius:35px;
   margin-bottom:25px;
   min-width:280px;
   text-align:center;
   color:white;
   font-weight: 1000;
   font-size: 1.25rem;
   line-height: 1.6;
   box-shadow:0 0 5px ${theme.palette.primary.main};
`